import { inject, Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';

import { NotificationActionApi } from '../api/notification-action.api';
import { NotificationSurveyCommentApi } from '../api/notification-survey-comment.api';
import {
  NotificationActionApplyResult,
  NotificationActionLiveState,
} from '../state/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationActionService {
  private readonly _notificationActionApi = inject(NotificationActionApi);
  private readonly _surveyCommentApi = inject(NotificationSurveyCommentApi);

  public apply(
    surveyId: string,
    commentId: string,
    actionId: string,
  ): Observable<NotificationActionApplyResult> {
    return this._notificationActionApi.apply(surveyId, commentId, actionId);
  }

  public undo(
    surveyId: string,
    commentId: string,
    actionId: string,
  ): Observable<NotificationActionApplyResult> {
    return this._notificationActionApi.undo(surveyId, commentId, actionId);
  }

  // One failing survey must not hide the live state of the others.
  public liveStates(
    surveyIds: string[],
  ): Observable<NotificationActionLiveState[]> {
    return forkJoin(
      surveyIds.map((surveyId) =>
        this._surveyCommentApi
          .actionLiveStates(surveyId)
          .pipe(catchError(() => of<NotificationActionLiveState[]>([]))),
      ),
    ).pipe(map((statesPerSurvey) => statesPerSurvey.flat()));
  }
}
